import addStaticMembersTo
import buildValues
import dev.shanty.kotwire.stimulus.Application
import dev.shanty.kotwire.stimulus.Event
import kotlin.Boolean
import kotlin.String
import kotlin.js.JsExport
import kotlin.reflect.KClass
import org.w3c.dom.HTMLElement

@JsExport
public interface PackingWhoControllerTargetLifecycleHooks {
  public fun storageKeyValueChanged(`value`: String, previousValue: String) {
  }
}

public fun PackingWhoController.storageKeyValue(): StimulusProperty<String> =
    StimulusProperty("storageKeyValue")

public fun PackingWhoController.hasStorageKeyValue(): Boolean {
  println(this.asDynamic()["hasStorageKeyValue"])
  return this.asDynamic()["hasStorageKeyValue"]
}

public fun registerPackingWhoController(stimulus: Application) {
   val clazz = PackingWhoController::class
   val properties = object  {
      // Js name needed otherwise Kotlin will mangle the name
      @JsName("targets")
      val targets = js("[]")

      @JsName("values")
      val values = buildValues(
          setOf(
              ValueDefinition("storageKey", "String", false)
          ),
          PackingWhoController.Values
      )
      
      
      
      @JsName("classes")
      val classes = js("[]")
  }

  val factoryFunc = clazz.js.asDynamic()

  addStaticMembersTo(factoryFunc, properties)
  val controllerName = "packingwho"
  println("Registering controller packingwho")

  stimulus.register(controllerName, factoryFunc)
}
